(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-pills"] && !Shopify.designMode) return;
  try {
    
      (() => {
        const slug = t => t.toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$|/g,'');
      
        const build = pillsSection => {
          const ul = pillsSection.querySelector('.category-pills__list');
          ul.innerHTML = '';
      
          const showcases = Array.from(document.querySelectorAll('[data-collection-showcase]'))
            .map(sc => ({
              el   : sc,
              slug : slug(sc.dataset.collectionHeading || ''),
              head : sc.dataset.collectionHeading || '',
              cnt  : sc.dataset.collectionCount   || '0',
              img  : sc.dataset.collectionImg     || ''
            })).filter(s => s.head);
      
          showcases.forEach(s => {
            const li = document.createElement('li');
            li.className = 'category-pill';
            li.dataset.slug = s.slug;
      
            if (s.img){
              li.innerHTML = `<div class="pill__img-wrapper"><img src="${s.img}" alt="${s.head}" loading="lazy"></div>`;
            }
            li.innerHTML += `<div class="pill"><span class="pill__title">${s.head}</span>
                             <small class="pill__subtitle">${s.cnt} products</small></div>`;
      
            li.addEventListener('click', () => toggle(s.slug, li, pillsSection));
            ul.appendChild(li);
          });
        };
      
        const toggle = (slugVal, clicked, pillsSection) => {
          const pills      = pillsSection.querySelectorAll('.category-pill');
          const showcases  = document.querySelectorAll('[data-collection-showcase]');
          const spacers    = document.querySelectorAll('.shopify-section.section-spacer');
      
          const reset = () => {
            pills.forEach(p => p.classList.remove('is-active'));
            showcases.forEach(sc => sc.classList.remove('is-hidden'));
            spacers.forEach(sp => sp.classList.remove('is-hidden'));
          };
      
          if (clicked.classList.contains('is-active')) { reset(); return; }
      
          reset();
          clicked.classList.add('is-active');
      
          showcases.forEach(sc => {
            if (slug(sc.dataset.collectionHeading || '') !== slugVal){
              sc.classList.add('is-hidden');
              const wrapper = sc.closest('.shopify-section');
              if (wrapper){
                const prev = wrapper.previousElementSibling;
                if (prev?.classList.contains('section-spacer')) prev.classList.add('is-hidden');
              }
            }
          });
        };
      
        const initAll = () => document.querySelectorAll('section.category-pills').forEach(build);
        document.addEventListener('DOMContentLoaded', initAll);
        document.addEventListener('shopify:section:load', e => {
          if (e.target.matches('section.category-pills')) build(e.target);
        });
      })();
      
  } catch(e) { console.error(e); }
})();
})();
